import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";
import { useScopeParams } from "@/hooks/useScopeParams";

type Props = { siteId: string };

export default function AdverseEventsTab({ siteId }: Props) {
  const { id } = useScopeParams();
  return (
    <MetadataDashboardTemplate
      type="adverse_events"
      siteId={siteId}
      selectionIdentifierColumn="subject"
      constants={{
        wikiLink: "/wiki/guides/exploration-safety-adverse-events",
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/adverse-events`,
      }}
    />
  );
}
